import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-review-tile',
  templateUrl: './review-tile.component.html',
  styleUrls: ['./review-tile.component.scss']
})
export class ReviewTileComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
